<template>
  <SmDialog v-model:visibility="visibility">
    <!-- Dialog header -->
    <template #title>
      <div class="dialog-header">
        <el-image
          class="application-image"
          :src="`https://logos.saasmetrix.io/${encodeURIComponent(props.applicationName)}.png`">
          <template #error>
            <ImageOff :size="28" />
          </template>
        </el-image>
        <h2>{{ applicationName }}: {{ i18n.t('2fa') }}</h2>
      </div>
    </template>
    <ApplicationAuthFlowContent
      :application-name="applicationName"
      :application-type="applicationType"
      :application-id="applicationId"
      :auth-type="authType"
      @authentication-completed="handleAuthenticationCompleted" />
  </SmDialog>
</template>

<script setup lang="ts">
  // Imports

  import { useI18n } from 'vue-i18n'

  import { SoftwareTypes } from '@/client'
  import { AuthType } from '@/stores/applicationReauthStore'

  import { ImageOff } from 'lucide-vue-next'

  const i18n = useI18n()

  const emit = defineEmits(['update:visibility', 'authentication-completed'])

  const props = defineProps<{
    visibility: boolean
    applicationName: string
    applicationId?: string
    applicationType: SoftwareTypes
    authType: AuthType
  }>()

  const visibility = computed({
    get() {
      return props.visibility
    },
    set(value: boolean) {
      emit('update:visibility', value)
    },
  })

  function handleAuthenticationCompleted() {
    emit('authentication-completed')
    visibility.value = false
  }
</script>

<style scoped lang="scss">
  .dialog-header {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    gap: 1rem;
  }
  .application-image {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 40px;
    width: 40px;
  }
</style>
